// NPM
import React from "react"

// Components
import Description from "src/components/Shared/Description"

const PanelSignup = ({ section }) => {
  if (!section) {
    return null
  }

  const hasUrl = section.link.url && section.link.url.length > 0
  const hasPagePath =
    section.link.page &&
    section.link.page.path &&
    section.link.page.path.length > 0

  const hasLink = hasUrl || hasPagePath
  const linkUrl = hasUrl ? section.link.url : section.link.page.path
  const linkTarget = linkUrl.startsWith("/") ? "_self" : "_blank"

  return (
    <div className="PanelSignup">
      <h4 className="PanelSignup__title">{section.title}</h4>

      <Description
        className="PanelSignup__description"
        description={section.description}
      />

      {hasLink && (
        <a
          href={linkUrl}
          target={linkTarget}
          className="PanelSignup__cta black-button"
        >
          <span>{section.link.text}</span>
          <span className="icon">
            <img
              src={require("src/images/icons/arrow-right-white.png").default}
            />
          </span>
        </a>
      )}
    </div>
  )
}

export default PanelSignup
